import { getProgrammeBySlug, hydrateProgramme } from "@/data/programmes_info";
import ProgrammeComponent from "@/components/Programme/ProgrammeComponent.vue";

export default {
  name: "Programme",
  props: {
    programmeSlug: {
      type: String,
      default: null
    }
  },
  components: {
      ProgrammeComponent
  },

  data() {
    return ({
      programme: null,
      dismissed_alerts: [],
      show_all_alerts: false
    });
  },

  computed: {
    iconStyle() {
      if (!this.programme?.theme) return {};
      const from = this.programme.theme.gradientFrom || "#22c55e";
      const to = this.programme.theme.gradientTo || "#14b8a6";
      return ({
        width: "56px",
        height: "56px",
        background: `linear-gradient(135deg, ${from}, ${to})`,
      });
    },

    alert_steps() {
      if (!this.programme?.steps) return [];
      return this.programme.steps.filter(step =>
        (step.status === 'overdue' || step.status === 'pending') &&
        !this.dismissed_alerts.includes(step.id)
      );
    },

    overdue_steps() {
      if (!this.programme?.steps) return [];
      return this.programme.steps.filter(step =>
        step.status === 'overdue' &&
        !this.dismissed_alerts.includes(step.id)
      );
    },

    visible_alert_steps() {
      if (this.show_all_alerts || this.alert_steps.length <= 3) {
        return this.alert_steps;
      }
      return this.alert_steps.slice(0, 3);
    },

    has_more_alerts() {
      return this.alert_steps.length > 3;
    },
  },

  mounted() {
    const slug = this.programmeSlug || this.$route?.params?.programme_name;
    this.loadProgramme(slug);
  },

  watch: {
    programmeSlug(newSlug) {
      const slug = newSlug || this.$route?.params?.programme_name;
      this.loadProgramme(slug);
    }
  },

  methods: {
    loadProgramme(programmeName) {
      const rawProgramme = getProgrammeBySlug(programmeName);
      this.programme = hydrateProgramme(rawProgramme);
    },

    badgeClass(status) {
      if (status === "completed") return "bg-success";
      if (status === "at risk") return "bg-warning text-dark";
      if (status === "on track") return "bg-success";
      return "bg-secondary";
    },

    readableStatus(s) {
      if (s === "in_progress") return "In Progress";
      if (s === "overdue") return "Overdue";
      if (s === "completed") return "Completed";
      if (s === "pending") return "Pending";
      return s;
    },

    stepBadgeClass(s) {
      if (s === "completed") return "complete-programme";
      if (s === "in_progress") return "inprogress-programme";
      if (s === "pending") return "pending-programme";
      return "bg-warning text-dark";
    },

    stepDotClass(s) {
      if (s === "completed") return "bg-success text-white";
      if (s === "in_progress") return "bg-primary text-white";
      if (s === "overdue") return "bg-danger text-white";
      return "bg-secondary text-white";
    },

    dismiss_alert(stepId) {
      this.dismissed_alerts.push(stepId);
    },

    toggleViewMore() {
      this.show_all_alerts = !this.show_all_alerts;
    },
  }
};

